/* ============================================================
   product-landing.js  —  Sección autónoma
   ============================================================ */

/* =================== CONFIG CENTRAL =========================
   Ajusta aquí el comportamiento sin tocar el resto del código. */
window.MI_CONFIG = {
  countdownHours: 3,        // Duración del contador de oferta (en horas).
  countdownReset: true,     // Reinicia automáticamente al llegar a 0.
  miniReviewMs: 5000        // Intervalo (ms) del slider de reseñas del hero.
};

/* App de checkout: el formulario Contra Entrega se inserta como
   bloque de app (@app) de "Releasit COD Form" desde el editor
   "Personalizar" de Shopify. No hay botón propio de añadir al carrito. */
window.CHECKOUT_APP = "Releasit COD Form";
/* ============================================================ */

(function () {
  function init(root) {
    if (!root || root.dataset.soReady) return;
    root.dataset.soReady = "1";

    /* ---- Galería: thumbnails -> imagen principal ---- */
    var mainImg = root.querySelector(".so-gallery__main img");
    var thumbs = root.querySelectorAll(".so-thumb");
    thumbs.forEach(function (t) {
      t.addEventListener("click", function () {
        var src = t.getAttribute("data-src");
        if (mainImg && src) mainImg.src = src;
        thumbs.forEach(function (x) { x.classList.remove("is-active"); });
        t.classList.add("is-active");
      });
    });

    /* ---- Countdown 3h con reinicio ---- */
    var cd = root.querySelector(".so-countdown");
    if (cd) {
      var hours = parseFloat(cd.getAttribute("data-hours")) || window.MI_CONFIG.countdownHours;
      var reset = window.MI_CONFIG.countdownReset;
      var key = "so_countdown_" + (root.getAttribute("data-section-id") || "x");
      var span = hours * 3600 * 1000;

      function target() {
        var stored = parseInt(localStorage.getItem(key), 10);
        var now = Date.now();
        if (!stored || stored <= now) {
          stored = now + span;
          if (reset || !localStorage.getItem(key)) localStorage.setItem(key, String(stored));
        }
        return stored;
      }
      var elH = cd.querySelector('[data-u="h"]');
      var elM = cd.querySelector('[data-u="m"]');
      var elS = cd.querySelector('[data-u="s"]');
      function pad(n){ return (n < 10 ? "0" : "") + n; }
      function tick() {
        var diff = target() - Date.now();
        if (diff <= 0) {
          if (reset) { localStorage.setItem(key, String(Date.now() + span)); diff = span; }
          else diff = 0;
        }
        var h = Math.floor(diff / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        if (elH) elH.textContent = pad(h);
        if (elM) elM.textContent = pad(m);
        if (elS) elS.textContent = pad(s);
      }
      tick();
      setInterval(tick, 1000);
    }

    /* ---- Mini slider de reseñas (hero) ---- */
    var mini = root.querySelector(".so-mini");
    if (mini) {
      var track = mini.querySelector(".so-mini__track");
      var slides = mini.querySelectorAll(".so-mini__slide");
      var i = 0, n = slides.length, timer = null;
      function go(k) { i = (k + n) % n; track.style.transform = "translateX(" + (-i * 100) + "%)"; }
      function auto() { timer = setInterval(function () { go(i + 1); }, window.MI_CONFIG.miniReviewMs); }
      function stop() { if (timer) clearInterval(timer); }
      var prev = mini.querySelector('[data-mini="prev"]');
      var next = mini.querySelector('[data-mini="next"]');
      if (prev) prev.addEventListener("click", function () { stop(); go(i - 1); auto(); });
      if (next) next.addEventListener("click", function () { stop(); go(i + 1); auto(); });
      if (n > 1) auto();
    }

    /* ---- Acordeón FAQ ---- */
    root.querySelectorAll(".so-acc__head").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var acc = btn.closest(".so-acc");
        var body = acc.querySelector(".so-acc__body");
        var open = acc.classList.toggle("is-open");
        body.style.maxHeight = open ? body.scrollHeight + "px" : "0px";
      });
    });
  }

  function boot() {
    document.querySelectorAll(".so-page").forEach(init);
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else { boot(); }

  // Recarga en el editor de temas de Shopify
  document.addEventListener("shopify:section:load", function (e) {
    var el = e.target.querySelector(".so-page");
    if (el) init(el);
  });
})();
